<template>
  <div class="sj-blank">
    <i class="icon_com comicon_blankdata" />
    <span class="text">{{ localText }}</span>
  </div>
</template>
<script>
/**
 * blank组件，当显示区域无内容时应显示该组件
 */
export default {
  name: "SjBlank",
  data() {
    return {
      /**
       * 组件内部文本
       */
      localText: ""
    };
  },
  props: {
    text: {
      default: "",
      type: String
    }
  },
  watch: {
    text: {
      immediate: true,
      handler() {
        /**
         * 根据props对组件内部文本赋值
         */
        if (!this.text) {
          try {
            this.localText = this.$t("common.others.nodata");
          } catch (e) {
            this.localText = "无数据";
          }
        } else {
          this.localText = this.text;
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.sj-blank {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  i {
    color: @color-light;
    font-size: 30px;
  }
  .text {
    margin-top: 10px;
    .text("caption", "light");
  }
}
</style>
